<template>
  <div id="main">
    <div class="main_top">
      <img src="@/assets/image/operate/daiyunying_banner.png" alt="" />
      <div class="top_btn" @click="toBottom">立即联系</div>
    </div>
    <div class="service">
      <div class="title wow bounceIn">
        <img class="imgs" src="@/assets/image/operate/icon_fuwu1.png" alt="" />
        <p class="text">已为800+企业提供新媒体代运营服务</p>
        <div class="line"></div>
      </div>
      <div class="service_box">
        <div class="list_box wow slideInLeft">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide>
              <div class="list">
                <div class="logo_box">
                  <img src="@/assets/image/operate/icon_xiaohs.png" alt="" />
                </div>
                <p class="name">小红书代运营</p>
                <p>
                  策划小红书笔记种草，KOL资源推广快速提高商品曝光率和订单量。
                </p>
                <div class="line1"></div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="list">
                <div class="logo_box">
                  <img src="@/assets/image/operate/weixinicon.png" alt="" />
                </div>
                <p class="name">微信代运营</p>
                <p>
                  行业定位分析，定制微博营销解决方案，有效实现品牌传播，促进市场新增长。
                </p>
                <div class="line2"></div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="list">
                <div class="logo_box">
                  <img src="@/assets/image/operate/weiboicon.png" alt="" />
                </div>
                <p class="name">微博代运营</p>
                <p>
                  策划小红书笔记种草，KOL资源推广快速提高商品曝光率和订单量。
                </p>
                <div class="line3"></div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="list">
                <div class="logo_box">
                  <img
                    src="@/assets/image/operate/icon_daiyunying.png"
                    alt=""
                  />
                </div>
                <p class="name">抖音代运营</p>
                <p>
                  定制企业个性化原创视频，打造爆款内容，获取海量粉丝，实现营销变现。
                </p>
                <div class="line4"></div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="list">
                <div class="logo_box">
                  <img src="@/assets/image/operate/icon_xmtzhyy.png" alt="" />
                </div>
                <p class="name">新媒体整合运营</p>
                <p>
                  强话题内容策略、差异化媒介策略击破目标受众群各个圈层，在品牌传播基础上实现产品营销增长。
                </p>
                <div class="line5"></div>
              </div>
            </swiper-slide>
            <div class="prev" slot="button-prev">
              <img src="@/assets/image/training/icon_zkh.png" alt="" />
            </div>
            <div class="next" slot="button-next">
              <img src="@/assets/image/training/icon_ykh.png" alt="" />
            </div>
          </swiper>
        </div>
        <div class="btn_box">
          <div class="btn" @click="toBottom">联系营销顾问</div>
        </div>
      </div>
    </div>
    <div class="option">
      <div class="title wow bounceIn">
        <img
          class="imgs"
          src="@/assets/image/operate/icon_fangfalun2.png"
          alt=""
        />
        <p class="text">运营方法论，助力企业成长</p>
        <div class="line"></div>
      </div>
      <div class="options_box">
        <div class="box_main wow slideInDown" data-wow-delay="0.2s">
          <div class="title_box">
            <p>品牌定位分析</p>
            <p>技术评估，有效定位精准用户</p>
          </div>
          <img class="top_img" src="@/assets/image/operate/icon_3.png" alt="" />
          <div class="list_text">
            <div class="list_box">
              <p>品牌现状诊断</p>
              <p>技术评估，针对客户的需求提出可行性的诊断与优化的建议。</p>
            </div>
            <div class="list_box">
              <p>品牌定位规划</p>
              <p>结合客户品牌、平台情况及推广方向做营销推广方案/脑图/简报。</p>
            </div>
            <div class="list_box">
              <p>品牌落地执行</p>
              <p>
                结合简报方案，有序的主动的与甲方客户对接细节，推送内容，推送活动。
              </p>
            </div>
          </div>
          <div class="bot_btn">
            <div class="btn_l" @click="toBottom">立即咨询</div>
            <div class="btn_r" @click="toBottom">免费诊断</div>
          </div>
        </div>
        <div class="box_main wow slideInDown" data-wow-delay="0.4s">
          <div class="title_box">
            <p>内容策划与运营</p>
            <p>技术性的评估，编辑爆品文案</p>
          </div>
          <img class="top_img" src="@/assets/image/operate/icon_2.png" alt="" />
          <div class="list_text">
            <div class="list_box">
              <p>内容策划及脚本撰写</p>
              <p>根据热点节气结合品牌调性进行内容规划创意，</p>
            </div>
            <div class="list_box">
              <p>创意H5</p>
              <p>制作交互动态的海报宣传物料</p>
            </div>
            <div class="list_box">
              <p>反馈表单</p>
              <p>制作可以收集客户信息的表单</p>
            </div>
            <div class="list_box">
              <p>内容策划及脚本撰写</p>
              <p>根据热点节气结合品牌调性进行内容规划创意，</p>
            </div>
          </div>
          <div class="bot_btn">
            <div class="btn_l" @click="toBottom">立即咨询</div>
            <div class="btn_r" @click="toBottom">免费诊断</div>
          </div>
        </div>
        <div class="box_main wow slideInDown" data-wow-delay="0.6s">
          <div class="title_box">
            <p>平台账号分析</p>
            <p>针对不同的平台，有专属方案定制</p>
          </div>
          <img class="top_img" src="@/assets/image/operate/icon_1.png" alt="" />
          <div class="list_text">
            <div class="list_box">
              <p>转化率</p>
              <p>形成矩阵效应，提高转化率，进行变现，</p>
            </div>
            <div class="list_box">
              <p>互动率</p>
              <p>引爆话题，提高趣味性，拉热度/脑图/简报。</p>
            </div>
            <div class="list_box">
              <p>浏览率</p>
              <p>抓精准用户，增强曝光率</p>
            </div>
            <div class="list_box">
              <p>点赞量</p>
              <p>抓住用户心理，引爆流量</p>
            </div>
          </div>
          <div class="bot_btn">
            <div class="btn_l" @click="toBottom">立即咨询</div>
            <div class="btn_r" @click="toBottom">免费诊断</div>
          </div>
        </div>
      </div>
    </div>
    <div class="advantage">
      <div class="title wow bounceIn">
        <img
          class="imgs"
          src="@/assets/image/operate/icon_youshiad.png"
          alt=""
        />
        <p class="text">我们的优势</p>
        <div class="line"></div>
      </div>
      <div class="ad_mian">
        <div class="ad_l">
          <div class="ad1 wow slideInLeft">
            <div class="cont">
              <p>社媒定位</p>
              <p>快速升级</p>
              <p>账号视觉、功能设置与展示快速整体升级</p>
            </div>
          </div>
          <div class="ad3 wow slideInLeft">
            <div class="cont">
              <p>私域构建</p>
              <p>社媒传播</p>
              <p>搭建私域流量，强化粉丝互动</p>
            </div>
          </div>
        </div>
        <div class="ad_c">
          <img src="@/assets/image/operate/icon_4dajiazhiyoushi.png" alt="" />
        </div>
        <div class="ad_r">
          <div class="ad2 wow slideInRight">
            <div class="cont">
              <p>爆文转化及用户增长</p>
              <p>内容营销及增长裂变</p>
              <p>多维度内容策略提升账号销售力</p>
            </div>
          </div>
          <div class="ad4 wow slideInRight">
            <div class="cont">
              <p>销售转化</p>
              <p>工具倍增</p>
              <p>利用销售工具，进转化销售，倍增销量</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="success">
      <div class="title wow bounceIn">
        <img
          class="imgs"
          src="@/assets/image/operate/icon_profect.png"
          alt=""
        />
        <p class="text">成功案例</p>
        <div class="line"></div>
      </div>
      <div class="profect">
        <div class="profect_box">
          <div class="case_box wow rollIn" data-wow-delay="0.2s">
            <div class="text_box">
              <div class="kong"></div>
              <div class="cont">
                <p>武笑天-职场江湖</p>
                <div class="cont_box">
                  <span>职场/创业/人性，带你聊聊那些职场江湖事</span>
                </div>
              </div>
            </div>
            <div class="img_box">
              <img src="@/assets/image/operate/01_tu.png" alt="" />
            </div>
            <div class="show_box">
              <p>内容定位:</p>
              <p>职场/创业/人性，带你聊聊那些职场江湖事</p>
              <p>客户需求:</p>
              <p>拉动粉丝增长，用户维护</p>
              <p>客户需求:</p>
              <p>深度原创内容/热点节日创意原文</p>
            </div>
          </div>
          <div class="case_box wow rollIn" data-wow-delay="0.3s">
            <div class="text_box">
              <div class="kong"></div>
              <div class="cont">
                <p>你好，Hea！</p>
                <div class="cont_box">
                  <span
                    >hea唧本意为找寻、探索、发现所以我哋喺嘻哈唧马尔代夫——广州，搞咗啲事。一件专注潮流文化唧club邀请你，同我哋一起探索音乐中唧记忆同美好</span
                  >
                </div>
              </div>
            </div>
            <div class="img_box">
              <img src="@/assets/image/operate/02_tu.png" alt="" />
            </div>
            <div class="show_box">
              <p>内容定位:</p>
              <p>
                hea唧本意为找寻、探索、发现
                所以我哋喺嘻哈唧马尔代夫——广州，搞咗啲事。
                一件专注潮流文化唧club 邀请你，同我哋一起探索音乐中唧记忆同美好
              </p>
              <p>客户需求:</p>
              <p>拉动粉丝增长，用户维护</p>
              <p>客户需求:</p>
              <p>深度原创内容/热点节日创意原文</p>
            </div>
          </div>
          <div class="case_box wow rollIn" data-wow-delay="0.4s">
            <div class="text_box">
              <div class="kong"></div>
              <div class="cont">
                <p>胡闹星球</p>
                <div class="cont_box">
                  <span
                    >【深夜酒馆】照片讲故事每张照片都有一段属于它的故事有些情感其实需要用酒精去酝酿在这里…总有一点故事能扣你心弦</span
                  >
                </div>
              </div>
            </div>
            <div class="img_box">
              <img src="@/assets/image/operate/03_tu.png" alt="" />
            </div>
            <div class="show_box">
              <p>内容定位:</p>
              <p>
                【深夜酒馆】照片讲故事每张照片都有一段属于它的故事有些情感其实需要用酒精去酝酿在这里…总有一点故事能扣你心弦
              </p>
              <p>客户需求:</p>
              <p>拉动粉丝增长，用户维护</p>
              <p>客户需求:</p>
              <p>深度原创内容/热点节日创意原文</p>
            </div>
          </div>
          <div class="case_box wow bounceInUp" data-wow-delay="0.5s">
            <div class="text_box">
              <div class="kong"></div>
              <div class="cont">
                <p>TCH旗舰店</p>
                <div class="cont_box">
                  <span>TCH 轻奢潮牌潮流文化基因</span>
                </div>
              </div>
            </div>
            <div class="img_box">
              <img src="@/assets/image/operate/04_tu.png" alt="" />
            </div>
            <div class="show_box">
              <p>内容定位:</p>
              <p>TCH 轻奢潮牌潮流文化基因</p>
              <p>客户需求:</p>
              <p>拉动粉丝增长，用户维护，提升品牌形象</p>
              <p>客户需求:</p>
              <p>深度原创内容/活动策划</p>
            </div>
          </div>
          <div class="case_box wow bounceInUp" data-wow-delay="0.6s">
            <div class="text_box">
              <div class="kong"></div>
              <div class="cont">
                <p>吾小历-时尚博主</p>
                <div class="cont_box">
                  <span>时尚博主</span>
                </div>
              </div>
            </div>
            <div class="img_box">
              <img src="@/assets/image/operate/05_tu.png" alt="" />
            </div>
            <div class="show_box">
              <p>内容定位:</p>
              <p>时尚博主</p>
              <p>客户需求:</p>
              <p>拉动粉丝增长，用户维护</p>
              <p>客户需求:</p>
              <p>深度原创内容/热点节日创意原文</p>
            </div>
          </div>
          <div class="case_box wow bounceInUp" data-wow-delay="0.7s">
            <div class="text_box">
              <div class="kong"></div>
              <div class="cont">
                <p>侯浩在巴蜀</p>
                <div class="cont_box">
                  <span>不负韶华 皆是良景爷爷的柴米油盐与婆婆的诗同在</span>
                </div>
              </div>
            </div>
            <div class="img_box">
              <img src="@/assets/image/operate/06_tu.png" alt="" />
            </div>
            <div class="show_box">
              <p>内容定位:</p>
              <p>不负韶华 皆是良景爷爷的柴米油盐与婆婆的诗同在</p>
              <p>客户需求:</p>
              <p>拉动粉丝增长，用户维护</p>
              <p>客户需求:</p>
              <p>深度原创内容/热点节日创意原文</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="process">
      <div class="title wow bounceIn">
        <img
          class="imgs"
          src="@/assets/image/operate/icon_process.png"
          alt=""
        />
        <p class="text">规范化服务流程，创造最佳商业内容</p>
        <div class="line"></div>
      </div>
      <div class="process_box">
        <div class="process_main">
          <div class="main_box wow bounceInUp" data-wow-delay="0.2s">
            <img
              class="main_img"
              src="@/assets/image/operate/01_tubiaoicon.png"
              alt=""
            />
            <div class="txt_box">
              <img src="@/assets/image/operate/01.png" alt="" />
              <span>账号认证</span>
            </div>
            <div class="line_box">
              <div class="line"></div>
              <p>></p>
            </div>
          </div>
          <div class="main_box wow bounceInUp" data-wow-delay="0.3s">
            <img
              class="main_img"
              src="@/assets/image/operate/icon_ricahngyunying.png"
              alt=""
            />
            <div class="txt_box">
              <img src="@/assets/image/operate/02.png" alt="" />
              <span>日常运营</span>
            </div>
            <div class="line2_box">
              <div class="line"></div>
              <p>></p>
            </div>
          </div>
          <div class="main_box wow bounceInUp" data-wow-delay="0.4s">
            <img
              class="main_img"
              src="@/assets/image/operate/icon_neirongchuangxin.png"
              alt=""
            />
            <div class="txt_box">
              <img src="@/assets/image/operate/03.png" alt="" />
              <span>内容创新及制作</span>
            </div>
            <div class="lin3_box">
              <div class="line"></div>
              <p>></p>
            </div>
          </div>
          <div class="main_box wow bounceInUp" data-wow-delay="0.5s">
            <img
              class="main_img"
              src="@/assets/image/operate/icon_huodongcehua.png"
              alt=""
            />
            <div class="txt_box">
              <img src="@/assets/image/operate/04.png" alt="" />
              <span>活动策划</span>
            </div>
            <div class="line_box">
              <div class="line"></div>
              <p>></p>
            </div>
          </div>
          <div class="main_box wow bounceInUp" data-wow-delay="0.6s">
            <img
              class="main_img"
              src="@/assets/image/operate/icon_fengsijilei.png"
              alt=""
            />
            <div class="txt_box">
              <img src="@/assets/image/operate/05.png" alt="" />
              <span>粉丝积累</span>
            </div>
            <div class="line_box">
              <div class="line"></div>
              <p>></p>
            </div>
          </div>
          <div class="main_box wow bounceInUp" data-wow-delay="0.7s">
            <img
              class="main_img"
              src="@/assets/image/operate/icon_dhangyebianxian.png"
              alt=""
            />
            <div class="txt_box">
              <img src="@/assets/image/operate/06.png" alt="" />
              <span>商业变现 </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sign" id="signform">
      <div class="top_img">
        <img src="@/assets/image/operate/bg_zanghaomianfei.png" alt="" />
        <div class="sign_box">
          <div class="label">
            <p>申请账号免费诊断</p>
            <p>填写资料后客服人员会主动联系您，为您账号免费诊断</p>
          </div>
          <div class="form_box">
            <el-form
              :model="form"
              ref="form"
              :rules="rules"
              label-width="80px"
              :inline="true"
              size="normal"
            >
              <el-form-item label="" prop="company_name" style="width: 484px">
                <el-input
                  v-model="form.company_name"
                  placeholder="企业名称"
                  maxlength="20"
                ></el-input>
              </el-form-item>
              <el-form-item label="" prop="name" style="width: 484px">
                <el-input
                  v-model="form.name"
                  placeholder="联系人姓名"
                  maxlength="6"
                ></el-input>
              </el-form-item>
              <el-form-item label="" prop="phone" style="width: 484px">
                <el-input
                  v-model="form.phone"
                  :onkeyup="form.phone=form.phone.replace(/[^\d]/g,'')"
                  maxlength="11"
                  placeholder="联系人电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="" prop="wx_number" style="width: 484px">
                <el-input
                  v-model="form.wx_number"
                  placeholder="联系人微信"
                  maxlength="11"
                ></el-input>
              </el-form-item>
              <el-form-item label="" class="textarea" prop="content" style="width: 990px">
                <el-input
                  type="textarea"
                  style="height:198px"
                  resize="none"
                  maxlength="100"
                  v-model="form.content"
                  placeholder="请输入您的其他需求"
                >
                </el-input>
                <span class="textnum">{{form.content.length}}/100</span>
              </el-form-item>
            </el-form>
            <div class="formbtn"  @click="handelForm">
              <span>提交信息</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import {WOW} from 'wowjs' 
export default {
  components: {
    swiper,
    swiperSlide,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  name: "",
  metaInfo() {
    return this.metaData;
  },
  data() {
    var validatePhone = (rule, value, callback) => {
      const phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value === '') {
        return callback(new Error('请输入手机号码'))
      } else if (phoneReg.test(value)) {
        return callback()
      } else {
        return callback(new Error('请输入正确手机号码'))
      }
    }
    return {
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        wx_number: [{ required: true, message: "请输入微信号", trigger: "blur" }],
        company_name: [{required: true,message: "请输入企业名称",trigger: "blur",}],
        phone: [{ required: true,  validator: validatePhone }],
        content: [{ required: true, message: "请输入您的其他需求", trigger: "blur" }],
      },
      form: {
        company_name: "",
        name: "",
        phone: "",
        wx_number: "",
        from: "官网",
        content: "",
      },
      swiperOption: {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 0,
        slidesPerGroup: 1,
        centeredSlides: false,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".next",
          prevEl: ".prev",
        },
      },
      metaData: {
        title: "公众号代运营_小红书代运营_抖音代运营_泽谷传媒", // set a title
        meta: [
          {
            // set meta
            name: "keyWords",
            content: "公众号代运营、小红书代运营、抖音代运营",
          },
          {
            name: "description",
            content:
              "泽谷传媒新媒体代运营团队,提供微信订阅号|服务号|微博内容运营、小红书代运营、抖音代运营等新媒体运营解决方案:4006520677。",
          },
        ],
      },
    };
  },
  methods: {
    toBottom(){
      window.scrollTo(0,document.getElementById('app').scrollHeight)
    },
    // 判断是否为移动端
    isMobile(ua) {
      return !!ua.match(/AppleWebKit.*Mobile.*/)
    },
    handelForm(){
      this.$refs.form.validate(valid=>{
        if(valid){
          this.axios.post('/v1/company_info',this.form).then(res=>{
            if(res.code===0){
              this.$message.success('提交成功,请等待回访')
              this.form.name=''
              this.form.phone=''
              this.form.content=''
              this.form.wx_number=''
            }
          })
        }
      })
    }
  },
  created(){
    if(this.isMobile(navigator.userAgent)){
      let url = window.location.origin.replace(/www./, "m.");
      window.location.href=url+'/page/h5/operate.html'
    }
  },
  mounted() {
    this.$nextTick(()=>{
      let wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true
    })
    wow.init()
    })
    
  },
};
</script>
<style lang="scss">
#main {
  .form_box{
    width: 990px;
    margin: 0 auto;
    .el-form{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .el-form-item{
        margin: 0 0 25px 0;
      }
    }
    .el-form-item__content::before{
        position: absolute;
        top: 0;
        right: 20px;
        display: block;
        width: 10px;
        height: 52px;
        line-height: 52px;
        content: "*";
        color: red;
        z-index: 99;
      }
    .el-form-item__content{
      width: 100%;
      .el-input,.el-input__inner{
        height: 52px;
        line-height: 52px;
        padding-right: 40px;
      }
      .el-textarea__inner{
        height: 100%;
      }
    }
    .textarea{
      position: relative;
      .textnum{
        position: absolute;
        bottom: 0;
        right: 15px;
        font-size: 12px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
#main {
  .main_top {
    width: 100%;
    min-width: 1200px;
    position: relative;
    img {
      display: block;
      width: 100%;
    }
    .top_btn {
      position: absolute;
      width: 200px;
      height: 56px;
      background: #f7b71f;
      box-shadow: 0px 10px 16px 0px rgba(48, 132, 255, 0.3);
      border-radius: 28px;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      line-height: 56px;
      text-align: center;
      bottom: 15%;
      right: 50%;
      margin-right: -100px;
      cursor: pointer;
    }
  }
  .service {
    padding: 30px 0 2px;
    min-width: 1200px;
    background: url(../../../assets/image/operate/bg_youshitiaowen.png)
      no-repeat;
    background-size: 100% 100%;
    .btn_box {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      .btn {
        margin: 0 auto;
        font-size: 20px;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 56px;
        width: 200px;
        height: 56px;
        background: #f7b71f;
        box-shadow: 0px 5px 16px 0px rgba(152, 166, 249, 0.58);
        border-radius: 28px;
        cursor: pointer;
      }
    }
    .service_box {
      width: 1200px;
      margin: 57px auto;
      .prev {
        position: absolute;
        left: 0;
        top: 50%;
        z-index: 5;
        cursor: pointer;
      }
      .next {
        position: absolute;
        right: 0;
        top: 50%;
        z-index: 5;
        cursor: pointer;
      }
      .list_box {
        margin: 50px 0 30px;
      }
      .list {
        width: 255px;
        height: 330px;
        background: #ffffff;
        position: relative;
        box-shadow: 0px 0px 13px 0px rgba(67, 30, 149, 0.12);
        border-radius: 5px;
        text-align: center;
        padding: 50px 20px 0;
        box-sizing: border-box;
        .name {
          margin: 30px 0 15px;
          font-size: 18px;
          font-weight: bold;
          color: #616975;
        }
        p {
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          color: #616975;
        }
        .line1 {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 4px;
          background: #ff5b5b;
        }
        .line2 {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 4px;
          background: #58bced;
        }
        .line3 {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 4px;
          background: #60ccc5;
        }
        .line4 {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 4px;
          background: #98a6f9;
        }
        .line5 {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 4px;
          background: #fcc622;
        }
        .logo_box {
          width: 100%;
          height: 30%;
          > img {
            width: 30%;
            height: 100%;
            object-fit: scale-down;
          }
        }
      }
    }
    .title {
      width: 1200px;
      height: 100px;
      text-align: center;
      margin: 0 auto;
      position: relative;
      box-sizing: border-box;
      .line {
        width: 40px;
        height: 6px;
        background: #6f63f7;
        border-radius: 3px;
        margin: 0 auto;
      }
      .text {
        position: absolute;
        z-index: 10;
        bottom: 10px;
        width: 100%;
        text-align: center;
        font-size: 32px;
        font-weight: bold;
        color: #2b3748;
      }
    }
  }
  .option {
    min-width: 1200px;
    background: url(../../../assets/image/operate/bg_fangfalun.png) no-repeat;
    background-size: 100% 100%;
    padding: 20px 0 0 0;
    > .title {
      width: 1200px;
      height: 100px;
      padding-top: 90px;
      text-align: center;
      margin: 0 auto;
      position: relative;
      box-sizing: border-box;
      .imgs {
        position: absolute;
        display: block;
        margin: 0 auto;
        z-index: 1;
        left: 28%;
        bottom: 24px;
      }
      .text {
        position: absolute;
        z-index: 10;
        bottom: 10px;
        width: 100%;
        text-align: center;
        font-size: 32px;
        font-weight: bold;
        color: #2b3748;
      }
      .line {
        width: 40px;
        height: 6px;
        background: #6f63f7;
        border-radius: 3px;
        margin: 0 auto;
      }
    }
    > .options_box {
      width: 1200px;
      height: 630px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 55px;
      margin: 50px auto 0;
      .box_main {
        width: 400px;
        height: 470px;
        background: #ffffff;
        box-shadow: 0px 0px 20px 0px rgba(40, 19, 2, 0.15);
        text-align: center;
        padding: 20px;
        box-sizing: border-box;
        .title_box {
          text-align: center;
          p {
            font-size: 14px;
            font-weight: 400;
            color: #7d8a9c;
          }
          p:first-child {
            font-size: 20px;
            font-weight: bold;
            color: #616975;
          }
        }
        .top_img {
          display: none;
          width: 115px;
          height: 115px;
          display: block;
          position: absolute;
          top: -60px;
          right: 50%;
          left: 146px;
        }
        .list_text {
          width: 320px;
          background: #f3f6f9;
          border-radius: 8px;
          margin: 0 auto;
          color: #616975;
          .list_box {
            text-align: left;
            font-size: 14px;
            line-height: 25px;
            padding: 20px 10px;
            border-bottom: 1px solid #dfe5e9;
            p:first-child {
              font-size: 14px;
              font-weight: bold;
              line-height: 25px;
            }
            P {
              margin: 0;
            }
          }
          .list_box:last-child {
            border: none;
          }
        }
        .bot_btn {
          display: none;
          margin-top: 15px;
          .btn_l {
            width: 145px;
            height: 43px;
            background: linear-gradient(82deg, #6f63f7, #866aec);
            border-radius: 5px;
            font-size: 14px;
            font-weight: 400;
            color: #fffefe;
            text-align: center;
            line-height: 43px;
            margin: 0 30px 0 40px;
            cursor: pointer;
          }
          .btn_r {
            width: 145px;
            height: 43px;
            background: linear-gradient(82deg, #ff5eb1, #ff73b9);
            border-radius: 5px;
            font-size: 14px;
            font-weight: 400;
            color: #fffefe;
            text-align: center;
            line-height: 43px;
            cursor: pointer;
          }
        }
      }
      .box_main:hover {
        width: 399px;
        height: 577px;
        background: #ffffff;
        box-shadow: 0px 0px 20px 0px rgba(40, 19, 2, 0.15);
        border-radius: 14px;
        position: relative;
        .title_box {
          text-align: center;
          margin-top: 35px;
          p {
            font-size: 14px;
            font-weight: 400;
            color: #7d8a9c;
          }
          p:first-child {
            font-size: 20px;
            font-weight: bold;
            color: #616975;
          }
        }
        .hovertitle {
          text-align: center;
          margin-top: 56px;
          p {
            font-size: 14px;
            font-weight: 400;
            color: #7d8a9c;
          }
          p:first-child {
            font-size: 20px;
            font-weight: bold;
            color: #616975;
          }
        }
        .top_img {
          width: 115px;
          height: 115px;
          display: block;
          position: absolute;
          top: -60px;
          right: 50%;
          left: 146px;
        }
        .list_text {
          width: 320px;
          margin: 0 auto;
          background: #fda028;
          border-radius: 8px;
          color: #ffffff;
          .hover_list {
            text-align: left;
            font-size: 14px;
            line-height: 25px;
            padding: 20px 10px;
            border-bottom: 1px solid #dfe5e9;
            p:first-child {
              font-size: 14px;
              font-weight: bold;
              line-height: 25px;
            }
            p {
              margin: 0;
            }
          }
          .list_box:last-child {
            border: none;
          }
        }
        .bot_btn {
          display: flex;
          justify-content: center;
          margin-top: 15px;
          .btn_l {
            width: 145px;
            height: 43px;
            background: linear-gradient(82deg, #6f63f7, #866aec);
            border-radius: 5px;
            font-size: 14px;
            font-weight: 400;
            color: #fffefe;
            text-align: center;
            line-height: 43px;
            margin: 0 30px 0 0;
            cursor: pointer;
          }
          .btn_r {
            width: 145px;
            height: 43px;
            background: linear-gradient(82deg, #ff5eb1, #ff73b9);
            border-radius: 5px;
            font-size: 14px;
            font-weight: 400;
            color: #fffefe;
            text-align: center;
            line-height: 43px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .advantage {
    min-width: 1200px;
    padding: 50px 0;
    background: #ffffff;
    > .title {
      width: 1200px;
      height: 100px;
      padding-top: 90px;
      text-align: center;
      margin: 0 auto;
      position: relative;
      box-sizing: border-box;
      .imgs {
        position: absolute;
        display: block;
        margin: 0 auto;
        z-index: 1;
        left: 25%;
        bottom: 24px;
      }
      .text {
        position: absolute;
        z-index: 10;
        bottom: 10px;
        width: 100%;
        text-align: center;
        font-size: 32px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2b3748;
      }
      .line {
        width: 40px;
        height: 6px;
        background: #6f63f7;
        border-radius: 3px;
        margin: 0 auto;
      }
    }
    > .ad_mian {
      width: 1200px;
      margin: 50px auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;
      .ad_l .ad1 {
        width: 380px;
        height: 124px;
        background: url("../../../assets/image/operate/youshi_01smdw.png")
          no-repeat;
        background-size: 100% 100%;
        object-fit: cover;
        position: relative;
        .cont {
          width: 65%;
          height: 100%;
          padding: 20px 10px;
          position: absolute;
          top: 0;
          right: 0;
          box-sizing: border-box;
          p {
            font-size: 14px;
            font-weight: 400;
            color: #616975;
            line-height: 20px;
            margin: 0;
          }
          p:first-child {
            font-size: 18px;
            font-weight: bold;
            color: #616975;
            margin-bottom: 10px;
          }
        }
      }
      .ad_l .ad3 {
        width: 380px;
        height: 124px;
        background: url("../../../assets/image/operate/youshi_03sygj.png")
          no-repeat;
        background-size: 100% 100%;
        object-fit: cover;
        position: relative;
        margin-top: 70px;
        .cont {
          width: 65%;
          height: 100%;
          padding: 20px 10px;
          position: absolute;
          top: 0;
          right: 0;
          box-sizing: border-box;
          p {
            font-size: 14px;
            font-weight: 400;
            color: #616975;
            line-height: 20px;
            margin: 0;
          }
          p:first-child {
            font-size: 18px;
            font-weight: bold;
            color: #616975;
            margin-bottom: 10px;
          }
        }
      }
      .ad_r .ad2 {
        width: 380px;
        height: 124px;
        background: url("../../../assets/image/operate/youshi_02bwzh.png")
          no-repeat;
        background-size: 100% 100%;
        object-fit: cover;
        position: relative;
        .cont {
          width: 65%;
          height: 100%;
          padding: 20px 10px 0 36px;
          position: absolute;
          top: 0;
          left: 0;
          box-sizing: border-box;
          p {
            font-size: 14px;
            font-weight: 400;
            color: #616975;
            line-height: 20px;
            margin: 0;
          }
          p:first-child {
            font-size: 18px;
            font-weight: bold;
            color: #616975;
            margin-bottom: 10px;
          }
        }
      }
      .ad_r .ad4 {
        width: 380px;
        height: 124px;
        background: url("../../../assets/image/operate/icon_xszh004.png")
          no-repeat;
        background-size: 100% 100%;
        object-fit: cover;
        position: relative;
        margin-top: 70px;
        .cont {
          width: 65%;
          height: 100%;
          padding: 20px 10px 0 36px;
          position: absolute;
          top: 0;
          left: 0;
          box-sizing: border-box;
          p {
            font-size: 14px;
            font-weight: 400;
            color: #616975;
            line-height: 20px;
            margin: 0;
          }
          p:first-child {
            font-size: 18px;
            font-weight: bold;
            color: #616975;
            margin-bottom: 10px;
          }
        }
      }
      .ad_c {
        width: 270px;
        height: 270px;
      }
      > img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .success {
    min-width: 1200px;
    background: url("../../../assets/image/operate/bg_chenggonganli.png")
      no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    > .title {
      width: 1200px;
      height: 100px;
      padding-top: 90px;
      text-align: center;
      margin: 35px auto 0;
      position: relative;
      box-sizing: border-box;
      .imgs {
        position: absolute;
        display: block;
        margin: 0 auto;
        z-index: 1;
        left: 34%;
        bottom: 24px;
      }
      .text {
        position: absolute;
        z-index: 10;
        bottom: 10px;
        width: 100%;
        text-align: center;
        font-size: 32px;
        font-weight: bold;
        color: #2b3748;
      }
      .line {
        width: 40px;
        height: 6px;
        background: #6f63f7;
        border-radius: 3px;
        margin: 0 auto;
      }
    }
    > .profect {
      width: 1200px;
      margin: 50px auto 30px;
      .profect_box {
        display: flex;
        flex-wrap: wrap;
        .case_box {
          width: 375px;
          height: 375px;
          margin-bottom: 40px;
          margin-right: 30px;
          position: relative;
          z-index: 1;
          .text_box {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 350px;
            height: 346px;
            background: #ffffff;
            box-shadow: 0px 0px 27px 0px rgba(15, 60, 152, 0.2);
            .kong {
              width: 100%;
              height: 240px;
            }
            .cont {
              text-align: center;
              padding: 0px 30px;
              p:first-child {
                font-size: 18px;
                font-weight: bold;
                color: #616975;
                margin-bottom: 25px;
              }
              .cont_box {
                text-align: left;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                span {
                  margin: 0;
                  font-size: 14px;
                  font-weight: 500;
                  color: #616975;
                  line-height: 20px;
                }
              }
            }
          }
          .img_box {
            position: absolute;
            top: 0;
            left: 0;
            width: 346px;
            height: 246px;
            img {
              z-index: 0;
            }
          }
          .show_box {
            display: none;
            position: absolute;
            top: -24px;
            left: 0px;
            width: 347px;
            height: 370px;
            background: rgba(61, 66, 184, 0.6);
            border-radius: 5px;
            padding: 30px 15px;
            font-size: 14px;
            font-weight: 500;
            color: #ffffff;
            line-height: 32px;
            z-index: 10;
            P {
              margin: 0;
            }
          }
        }
        .case_box:hover {
          .show_box {
            display: block;
            box-sizing: border-box;
            text-align: left;
          }
          .img_box {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 3;
            width: 346px;
            height: 246px;
            background: rgba(204, 204, 204, 0.58);
            -webkit-filter: blur(5px);
            -moz-filter: blur(5px);
            -ms-filter: blur(5px);
            filter: blur(5px);
            filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius='5');
          }
          .text_box {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 350px;
            height: 346px;
            background: rgba(255, 255, 255, 0.58);
            -webkit-filter: blur(5px);
            -moz-filter: blur(5px);
            -ms-filter: blur(5px);
            filter: blur(5px);
            filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius='5');
          }
        }
      }
      .profect_box :nth-child(3),
      .profect_box :nth-child(6) {
        margin-right: 0px;
      }
    }
  }
  .process {
    min-width: 1200px;
    padding: 50px 0;
    background: #ffffff;
    .title {
      width: 1200px;
      height: 100px;
      padding-top: 90px;
      text-align: center;
      margin: 0 auto;
      position: relative;
      box-sizing: border-box;
      .imgs {
        position: absolute;
        display: block;
        margin: 0 auto;
        z-index: 1;
        left: 34%;
        bottom: 24px;
      }
      .text {
        position: absolute;
        z-index: 10;
        bottom: 10px;
        width: 100%;
        text-align: center;
        font-size: 32px;
        font-weight: bold;
        color: #2b3748;
      }
      .line {
        width: 40px;
        height: 6px;
        background: #6f63f7;
        border-radius: 3px;
        margin: 0 auto;
      }
    }
    .process_box {
      width: 1200px;
      margin: 50px auto 30px;
      .process_main {
        display: flex;
        justify-content: space-between;
        .main_box {
          position: relative;
          .main_img {
            display: block;
            width: 70px;
            height: 70px;
            margin: 0 auto;
          }
          .txt_box {
            margin-top: 10px;
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: #616975;
          }
          .line_box {
            position: absolute;
            top: 6px;
            left: 83px;
            width: 134px;
            color: #846aed;
            line-height: 50px;
            text-align: right;
            .line {
              position: absolute;
              top: 26px;
              left: 0px;
              width: 129px;
              border-bottom: 1px solid #d8d3fd;
            }
          }
          .line2_box {
            position: absolute;
            top: 6px;
            left: 97px;
            width: 134px;
            color: #846aed;
            line-height: 50px;
            text-align: right;
            .line {
              position: absolute;
              top: 26px;
              left: -8px;
              width: 134px;
              border-bottom: 1px solid #d8d3fd;
            }
          }
          .lin3_box {
            position: absolute;
            top: 6px;
            left: 118px;
            width: 134px;
            color: #846aed;
            line-height: 50px;
            text-align: right;
            .line {
              position: absolute;
              top: 26px;
              left: -8px;
              width: 134px;
              border-bottom: 1px solid #d8d3fd;
            }
          }
        }
      }
    }
  }
  .sign {
    height: 820px;
    min-width: 1200px;
    .top_img {
      min-width: 1200px;
      position: relative;
      > img {
        display: block;
        width: 100%;
      }
      .sign_box {
        position: absolute;
        top: 90px;
        left: 50%;
        margin-left: -600px;
        width: 1200px;
        height: 658px;
        background: #ffffff;
        box-shadow: 0px 0px 18px 0px rgba(12, 5, 29, 0.12);
        border-radius: 5px 0px 0px 0px;
        .label {
          text-align: center;
          padding: 40px 0;
          p {
            font-size: 14px;
            font-weight: 400;
            color: #7d8a9c;
            line-height: 24px;
          }
          p:first-child {
            font-size: 32px;
            font-weight: bold;
            color: #2b3748;
          }
        }
      }
    }
    .formbtn{
          margin: 20px auto 0;
      width: 322px;
      height: 52px;
      background: #F7B71F;
      box-shadow: 0px 6px 10px 0px rgba(152, 166, 249, 0.45);
      border-radius: 26px;
      text-align: center;
      line-height: 52px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}
</style>
